var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-cloud-upload" }
          }),
          _vm._v(" " + _vm._s(_vm.$t("import")) + "\n        ")
        ],
        1
      ),
      _c("p", { staticClass: "q-mb-none text-weight-light" }, [
        _vm._v(
          "\n                " +
            _vm._s(_vm.$t("store_import_template_start")) +
            "\n                "
        ),
        _c(
          "span",
          {
            staticClass: "text-weight-medium cursor-pointer",
            on: {
              click: function($event) {
                return _vm.getTemplateUser()
              }
            }
          },
          [_vm._v(" import_company_layout.xlsx")]
        ),
        _vm._v(
          "\n\t\t\t    " +
            _vm._s(_vm.$t("store_import_template_end")) +
            "\n            "
        )
      ]),
      _c("br"),
      _c("uploader", {
        attrs: {
          content_type: "xlsx",
          multiple: false,
          cropper: false,
          error: _vm.$v.file.$error
        },
        on: {
          fileUploaded: _vm.imageDesktopUploaded,
          input: _vm.$v.file.$touch
        }
      }),
      _c("div", { staticClass: "row gutter-sm justify-end q-mt-ld q-mb-xl" }, [
        _c(
          "div",
          { staticClass: "col-xs-12 col-sm-3" },
          [
            _c("q-btn", {
              staticClass: "full-width",
              attrs: {
                color: "secondary",
                label: _vm.$t("upload"),
                icon: "far fa-upload"
              },
              on: {
                click: function($event) {
                  return _vm.validateLines()
                }
              }
            })
          ],
          1
        )
      ]),
      _vm.branches.length > 0
        ? _c("h4", { staticClass: "q-my-md" }, [
            _vm._v(_vm._s(_vm.$t("all_store_errors")))
          ])
        : _vm._e(),
      _vm.branches.length > 0
        ? _c("q-table", {
            attrs: {
              data: _vm.branches,
              columns: _vm.columns,
              filter: _vm.filter,
              "row-key": "line"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      [
                        _c("q-td", { key: "line", attrs: { props: props } }, [
                          _vm._v(_vm._s(props.row.line))
                        ]),
                        _c("q-td", { key: "name", attrs: { props: props } }, [
                          _vm._v(_vm._s(props.row.name))
                        ]),
                        _c(
                          "q-td",
                          { key: "status_message", attrs: { props: props } },
                          [
                            _vm._v(
                              _vm._s(
                                props.row.status_message
                                  .map(function(e) {
                                    return _vm.$t(e)
                                  })
                                  .join(", ")
                              )
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          {
                            key: "error_count",
                            attrs: { props: props, "auto-width": "" }
                          },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  small: "",
                                  icon: _vm.getIconStatus(
                                    props.row.error_count
                                  ),
                                  color: _vm.getColorStatus(
                                    props.row.error_count
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.getStatus(props.row.error_count)
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              835590238
            )
          })
        : _vm._e(),
      _vm.companies.length > 0
        ? _c("h4", { staticClass: "q-my-md" }, [
            _vm._v(_vm._s(_vm.$t("all_headquarters_errors")))
          ])
        : _vm._e(),
      _vm.companies.length > 0
        ? _c("q-table", {
            attrs: {
              data: _vm.companies,
              columns: _vm.columns,
              filter: _vm.filter,
              "row-key": "line"
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      [
                        _c("q-td", { key: "line", attrs: { props: props } }, [
                          _vm._v(_vm._s(props.row.line))
                        ]),
                        _c("q-td", { key: "name", attrs: { props: props } }, [
                          _vm._v(_vm._s(props.row.name))
                        ]),
                        _c(
                          "q-td",
                          { key: "status_message", attrs: { props: props } },
                          [
                            _vm._v(
                              _vm._s(
                                props.row.status_message
                                  .map(function(e) {
                                    return _vm.$t(e)
                                  })
                                  .join(", ")
                              )
                            )
                          ]
                        ),
                        _c(
                          "q-td",
                          {
                            key: "error_count",
                            attrs: { props: props, "auto-width": "" }
                          },
                          [
                            _c(
                              "q-chip",
                              {
                                staticClass: "full-width",
                                attrs: {
                                  small: "",
                                  icon: _vm.getIconStatus(
                                    props.row.error_count
                                  ),
                                  color: _vm.getColorStatus(
                                    props.row.error_count
                                  )
                                }
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.$t(
                                        _vm.getStatus(props.row.error_count)
                                      )
                                    ) +
                                    "\n                    "
                                )
                              ]
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  }
                }
              ],
              null,
              false,
              835590238
            )
          })
        : _vm._e(),
      _vm.button
        ? _c("div", [
            _c("div", { staticClass: "q-pa-md bg-green-2" }, [
              _c("p", { staticClass: "q-mb-none" }, [
                _vm._v(
                  _vm._s(_vm.$t("all_headquarters")) +
                    " " +
                    _vm._s(_vm.qtd_companies)
                )
              ]),
              _c("p", { staticClass: "q-mb-none" }, [
                _vm._v(
                  _vm._s(_vm.$t("all_store")) + "  " + _vm._s(_vm.qtd_branches)
                )
              ])
            ]),
            _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "negative",
                      label: _vm.$t("cancel"),
                      icon: "far fa-trash-alt"
                    },
                    on: {
                      click: function($event) {
                        return _vm.cancel()
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-xs-12 col-sm-3" },
                [
                  _c("q-btn", {
                    staticClass: "full-width",
                    attrs: {
                      color: "secondary",
                      label: _vm.$t("save"),
                      icon: "far fa-save"
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveData()
                      }
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _c(
        "q-dialog",
        {
          attrs: { cancel: false },
          on: {
            ok: function($event) {
              return _vm.hideError()
            }
          },
          model: {
            value: _vm.show_message,
            callback: function($$v) {
              _vm.show_message = $$v
            },
            expression: "show_message"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v("Atenção")
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "Aguarde, a importação de redes e lojas está sendo processada. Você será notificado(a) no final do processo"
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }